import {Controller} from "stimulus";

export default class extends Controller {
  connect() {
    if (this.refreshValue === 0) return;

    console.log(this.refreshValue)

    this.timer = setInterval(() => {
      window.location.reload();
    }, this.refreshValue * 1000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  get refreshValue() {
    const value = this.element.dataset.autoRefreshRefreshValue;
    return value ? Number(value) : this.defaultRefresh;
  }

  get defaultRefresh() {
    return 60 * 10;
  }
}
